export function normalizeFeaturedProducts(featuredProducts) {
    const items = Array.isArray(featuredProducts) ? featuredProducts : [];

    return items.reduce((tags, featuredProduct) => {
        if (!featuredProduct?.product?.title || !featuredProduct?.url) {
            return tags;
        }

        const tag = {
            label: featuredProduct.product.title,
            url: featuredProduct.url,
        };

        if (featuredProduct.uid) {
            tag.uid = featuredProduct.uid;
        }

        const tone = featuredProduct.stain || featuredProduct.color;
        if (tone?.color) {
            tag.color = tone.color;
        }
        if (tone?.title) {
            tag.colorName = tone.title;
        }

        tags.push(tag);
        return tags;
    }, []);
}
